module.exports = __webpack_public_path__ + "static/media/anc7ru.31f49c9b.pdf";